import {
  fullNameSchema,
  fullNameUI,
  titleUI,
  dateOfBirthSchema,
  dateOfBirthUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['child-info-title']),
    // Change to claimantName, used only for custodian relationship
    childFullName: fullNameUI(),
    // Change to claimantDateOfBirth, used only for custodian relationship
    childDateOfBirth: dateOfBirthUI({
      monthSelect: false,
    }),
  },
  schema: {
    type: 'object',
    required: ['childFullName', 'childDateOfBirth'],
    properties: {
      childFullName: fullNameSchema,
      childDateOfBirth: dateOfBirthSchema,
    },
  },
};
